/**
 * Maximum allowed size in bytes
 */
export const MAX_ALLOWED_SIZE = 10 * 1024 * 1024;

export const DATAGRID_PAGE_SIZE_OPTIONS = [50, 100];
export const DATAGRID_DEFAULT_PAGE_SIZE = 50;

// @TODO, 1 year minus 45 days
// export const DEFAULT_EXPIRE_DATE = 

// API KEYS
export const DUB_API_KEY = process.env.REACT_APP_DUB_API_KEY || "dub_Sls8gIbuZnW7JWJRzWwnchkA";
